import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Loader from '../../../../services/loader';
import { useModal } from '../../../../services/customHooks';
import translate from '../../../../commonComponents/translate';
import SubHeader from '../../../../commonComponents/pageLayout/SubHeader';
import TopicBanner from '../../../../commonComponents/pageLayout/header/TopicBanner';
import Title from '../../../../commonComponents/Title';
import ContentContainer from '../../../../commonComponents/pageLayout/ContentContainer';
import LoggedUserContext from '../../../../contextProviders/LoggedUserContext';
import BonusListFilters from './BonusListFilters';
import Notifications from '../../../../services/notifications';
import BonusListData from './BonusListData';
import BonusListDataItemBlockModal from './modals/BonusListDataItemBlockModal';
import ReportTabBtns from '../../tab/ReportTabBtns';
import { REPORT_TAB_TYPE } from '../../propTypes/reportTabProp';

function BonusListPage(props) {
  const { t, _csrf } = props;

  const loader = useRef(new Loader('#pureliink-bonus-list'));
  const [isLoading, setLoading] = useState(false);
  const { loggedUser } = useContext(LoggedUserContext);

  const [listDetailModal, setListDetailModal] = useModal({
    show: false,
    data: null,
  });

  const [filters, setFilters] = useState({
    user: loggedUser._id,
  });

  const [bonusListData, setBonusListData] = useState([]);

  const handleGetBonusListInfo = useCallback(() => {
    if (filters.user) {
      setLoading(true);
      axios
        .get(`/api/tailor-made/pureliink/report/${filters.user}/bonus/list`, {
          headers: {
            'Accept-Version': '1.0.0',
            'X-Gamification-API': 'Games',
            'X-CSRF-Token': _csrf,
            _csrf,
          },
        })
        .then(({ data: response }) => {
          setBonusListData(response.data);
          setLoading(false);
        })
        .catch(err => {
          setLoading(false);
          console.log(err);
          Notifications.showErrorFromRequest(err, 'error_fetchBonusListData');
        });
    }
  }, [filters]);

  useEffect(() => {
    if (loader.current) {
      if (isLoading) {
        loader.current.show();
      } else {
        loader.current.hide();
      }
    }
  }, [isLoading]);

  useEffect(() => {
    handleGetBonusListInfo();
  }, [filters]);

  const handleFiltersChange = useCallback(
    field => value =>
      setFilters(prevState => ({ ...prevState, [field]: value })),
    [setFilters],
  );

  const handleClickSeeAll = listDataItem => {
    setListDetailModal({
      show: true,
      data: {
        type: listDataItem.type,
        sponsorId: filters.user,
      },
    });
  };

  const handleCloseModal = () => {
    setListDetailModal({
      show: false,
      data: null,
    });
  };

  return (
    <>
      {listDetailModal.show && (
        <BonusListDataItemBlockModal
          t={t}
          data={listDetailModal.data}
          handleCloseModal={handleCloseModal}
        />
      )}
      <Title title={t('header_bonusList')}>
        <ContentContainer>
          <SubHeader title={t('header_bonusList')} />
          <TopicBanner />
          <div className="m-content" id="pureliink-bonus-list">
            <div className="container">
              <div className="card">
                <div className="card-body">
                  <ReportTabBtns tabActive={REPORT_TAB_TYPE.BONUS_LIST} />
                </div>
              </div>
              <BonusListFilters
                t={t}
                filters={filters}
                loggedUser={loggedUser}
                onFilterChange={handleFiltersChange}
              />
              <BonusListData
                t={t}
                listData={bonusListData}
                handleClickSeeAll={handleClickSeeAll}
              />
            </div>
          </div>
        </ContentContainer>
      </Title>
    </>
  );
}

BonusListPage.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
};

export default translate(BonusListPage);
